export default {
  'HireMusicianModal.card': { en: 'Card', fr: 'Carte' },
  'HireMusicianModal.check': { en: 'By check', fr: 'Par chèque' },
};
